(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hilbert-ring-sizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hilbert-ring-sizer')) {
    class HilbertRingSizer extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.cardRange = this.querySelector('[id$="-card"]');
        this.diameterRange = this.querySelector('[id$="-diameter"]');
        this.sizes = JSON.parse(this.querySelector('[data-ring-sizes]').textContent);
        this.pxPerMm = 3.78;
        this.addEventListener('input', (event) => event.stopPropagation());
        this.addEventListener('change', (event) => event.stopPropagation());
        this.querySelector('.hilbert-ring-sizer__trigger').addEventListener('click', () => this.open());
        this.querySelector('.hilbert-ring-sizer__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
        this.querySelectorAll('[data-action]').forEach((button) => button.addEventListener('click', () => this.action(button.dataset.action)));
        this.cardRange.addEventListener('input', () => this.updateCard());
        this.diameterRange.addEventListener('input', () => this.updateMeasurement());
        this.updateCard();
        this.updateMeasurement();
      }

      track(event) {
        window.dataLayer?.push({ event });
        document.dispatchEvent(new CustomEvent(event, { detail: { productId: this.picker()?.dataset.productId } }));
      }

      picker() {
        return document.querySelector(`variant-picker[data-section-id="${this.dataset.sectionId}"]`);
      }

      open() {
        this.showStep('intro');
        this.dialog.showModal();
        this.track('ring_sizer_open');
      }

      action(name) {
        if (name === 'calibrate') { this.showStep('calibrate'); this.track('ring_sizer_start'); }
        if (name === 'manual') this.showStep('manual');
        if (name === 'measure') {
          const card = this.querySelector('.hilbert-ring-sizer__card');
          this.pxPerMm = card.getBoundingClientRect().width / 53.98;
          this.showStep('measure');
          this.updateMeasurement();
        }
        if (name === 'select-size') this.selectSize();
      }

      showStep(name) {
        this.querySelectorAll('[data-step]').forEach((step) => { step.hidden = step.dataset.step !== name; });
      }

      updateCard() {
        this.style.setProperty('--card-width', `${this.cardRange.value}px`);
      }

      updateMeasurement() {
        const diameter = Number(this.diameterRange.value);
        const size = Math.round(diameter * Math.PI);
        const matching = this.sizes.find((item) => Number.parseInt(item.name.match(/\d+/)?.[0], 10) === size && item.available);
        this.style.setProperty('--circle-size', `${diameter * this.pxPerMm}px`);
        this.querySelector('[data-result-size]').textContent = this.dataset.resultTemplate.replace('[size]', size);
        this.querySelector('[data-result-diameter]').textContent = diameter.toLocaleString(document.documentElement.lang || 'da-DK', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        this.querySelector('[data-select-label]').textContent = this.querySelector('[data-select-label]').textContent.replace(/\d+/, size);
        this.querySelector('[data-action="select-size"]').hidden = !matching;
        this.querySelector('[data-unavailable]').hidden = Boolean(matching);
        this.selectedSize = size;
      }

      selectSize() {
        const picker = this.picker();
        if (!picker) return;
        const position = this.dataset.optionPosition;
        const target = [...picker.querySelectorAll(`[data-input-id^="${position}-"]`)].find((input) => Number.parseInt(input.value?.match(/\d+/)?.[0], 10) === this.selectedSize);
        if (!target) return;
        if (target.tagName === 'OPTION') {
          target.parentElement.value = target.value;
          target.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.track('ring_size_selected');
        this.track('ring_sizer_complete');
        this.dialog.close();
      }
    }
    customElements.define('hilbert-ring-sizer', HilbertRingSizer);
  }
  } catch(e) { console.error(e); }
})();

})();
